<template>
  <div class="content-box mb120" v-if="isPasswordChecked">
    <!-- 마이페이지 사용자정보 -->
    <HconMyPageUsrInfo />
    <div class="sub-wrapper">
      <!-- 마이페이지 사이드 메뉴 -->
      <HconMyPageSideMenu />
      <div class="sub-contents member-edit">
        <form action="/" method="post" @submit.prevent>
          <!-- 사업자 인증 정보 영역 -->
          <div class="content-box mt0">
            <div class="border-title title check-title jc-l">
              <h3 class="title">사업자 인증 정보</h3>
              <span class="icon-check on"></span>
            </div>
            <div class="contents-detail-wrap">
              <fieldset>
                <legend class="a11y-blind">사업자 인증 수정 필드 영역입니다.</legend>
                <div class="form-box mb28">
                  <div class="form-group row">
                    <strong class="inp-label">사업자등록번호</strong>
                    <span class="col2">{{usrInfo?.bzrn.slice(0,3)}}-{{usrInfo?.bzrn.slice(3,5)}}-{{usrInfo?.bzrn.slice(5,10)}}</span>
                  </div>
                </div>
                <div class="form-box mb28">
                  <div class="form-group row">
                    <strong class="inp-label">상호(회사명)</strong>
                    <span class="col2">{{usrInfo?.bzcoNm}}</span>
                  </div>
                </div>
                <div class="form-box mb28">
                  <div class="form-group row">
                    <strong class="inp-label">대표자명</strong>
                    <span class="col2">{{usrInfo?.rpsrNm}}</span>
                  </div>
                </div>
                <div class="form-box mb28">
                  <div class="form-group row" :class="{'error': isBizcCdBiztpCdError || isBizcNmBiztpNmError}">
                    <label for="" class="inp-label">업태/종목</label>
                    <div class="col2">
                      <div class="col" :class="{'error': isBizcCdError || isBizcNmError}">
                        <HconDropDown type="dropdownBox" placeholder="업태 선택" selectBoxTitleClass="md wd329" v-model:model-value="selectedBizcCd" :dropdownOptions="bizcInfoList"/>
                        <div class="form-group mt10">
                          <HconInput type="text" v-model:model-value="inputBizcNm" label="업태 직접입력" :hide-label="true" inputClass="md" placeholder="업태 직접입력" v-if="selectedBizcCd === 'Z'"/>
                        </div>
                        <p v-if="(isBizcCdError && isBizcCdErrorType === 'null') && (selectedBizcCd === null || selectedBizcCd === '')" class="helper-text error">
                          {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"업태를","선택")}} <!-- {업태를} {선택}해 주세요. -->
                        </p>
                        <p v-if="(isBizcNmError && isBizcNmErrorType === 'null') && (inputBizcNm === null || inputBizcNm === '')" class="helper-text error">
                        {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"업태 직접입력을","입력")}} <!-- {업태 직접입력을} {입력}해 주세요. -->
                        </p>
                      </div>
                      <div class="col" :class="{'error': isBiztpCdError || isBiztpNmError}">
                        <HconDropDown type="dropdownBox" placeholder="종목 선택" selectBoxTitleClass="md wd329" v-model:model-value="selectedBiztpCd" :dropdownOptions="biztpInfoList"/>
                        <div class="form-group mt10">
                          <HconInput type="text" v-model:model-value="inputBiztpNm" label="종목 직접입력" :hide-label="true" inputClass="md" placeholder="종목 직접입력" v-if="selectedBiztpCd === '999999'"/>
                        </div>
                        <p v-if="(isBiztpCdError && isBiztpCdErrorType === 'null') && (selectedBiztpCd === null || selectedBiztpCd === '')" class="helper-text error">
                          {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"종목을","선택")}} <!-- {종목을} {선택}해 주세요. -->
                        </p>
                        <p v-if="(isBiztpNmError && isBiztpNmErrorType === 'null') && (inputBiztpNm === null || inputBiztpNm === '')" class="helper-text error">
                          {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"종목 직접입력을","입력")}} <!-- {종목 직접입력을} {입력}해 주세요. -->
                        </p>
                      </div>
                    </div>
                  </div>
                  <p v-if="(isBizcCdBiztpCdError && isBizcCdBiztpCdErrorType === 'null')" class="helper-text error">
                    {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"업태와 종목을 모두","선택")}} <!-- {업태와 종목을 모두} {선택}해 주세요. -->
                  </p>
                  <p v-if="isBizcNmBiztpNmError && isBizcNmBiztpNmErrorType === 'null'" class="helper-text error">
                    {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"업태와 종목 직접입력을 모두","입력")}} <!-- {업태와 종목 직접입력을 모두} {입력}해 주세요. -->
                  </p>
                </div>
                <div class="form-box mb28">
                  <div class="form-group row" :class="{'error': isAddressError}">
                    <HconInput type="text" ref="inputAddressRef" v-model:model-value="inputAddress" label="사업장 주소" :hide-label="false" inputClass="md" placeholder="사업장 주소를 입력하세요"/>
                  </div>
                  <p v-if="isAddressError && isAddressErrorType === 'null'" class="helper-text error">
                    {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"사업장 주소를","입력")}} <!-- {사업장 주소를} {입력}해 주세요. -->
                  </p>
                </div>
              </fieldset>
            </div> 
          </div> 
          <!-- 회원 정보 영역 -->
          <div class="content-box">
            <div class="border-title title">
              <h3 class="title">회원 정보</h3>
            </div>
            <div class="contents-detail-wrap">
              <fieldset>
                <legend class="a11y-blind">회원정보 수정 필드 영역입니다.</legend>
                <div class="form-box mb28">
                  <div class="form-group row">
                    <strong class="inp-label">아이디</strong>
                    <span class="col2">{{userId}}</span>
                  </div>
                </div>
                <div class="form-box mb28">
                  <div class="form-group row" :class="{'error': isPasswordError}">
                    <HconInput type="password" ref="inputPasswordRef" v-model:model-value="inputPassword" label="비밀번호" :hide-label="false" inputClass="md" placeholder="비밀번호를 입력해주세요"/>
                  </div>
                  <p v-if="isPasswordError && isPasswordErrorType === 'format1'" class="helper-text error">
                    {{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9020)}} <!-- 영문, 숫자, 특수문자 포함으로 9~20자리로 입력해 주세요. -->
                  </p>
                  <p v-if="isPasswordError && isPasswordErrorType === 'format2'" class="helper-text error">
                    {{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9021)}} <!-- 연속된 문자/숫자, 동일한 문자/숫자 3회 이상 사용 불가능합니다. -->
                  </p>
                  <p class="helper-text">* 영문, 숫자, 특수문자 포함으로 9~20자리로 입력해주세요</p>
                </div>
                <div class="form-box mb28">
                  <div class="form-group row" :class="{'error': isPasswordCheckError}">
                    <HconInput type="password" ref="inputPasswordCheckRef" v-model:model-value="inputPasswordCheck" label="비밀번호 확인" :hide-label="false" inputClass="md" placeholder="비밀번호를 다시 입력해주세요"/>
                  </div>
                  <p v-if="isPasswordCheckError && isPasswordCheckErrorType === 'null'" class="helper-text error">
                    {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"비밀번호 확인란을","입력")}} <!-- {비밀번호 확인란을} {입력}해 주세요. -->
                  </p>
                  <p v-if="isPasswordCheckError && isPasswordCheckErrorType === 'match'" class="helper-text error">
                    {{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9005,"입력하신 비밀번호가")}} <!-- {입력하신 비밀번호가} 일치하지 않습니다. 다시 입력해 주세요. -->
                  </p>
                  <p class="helper-text">* 입력하신 비밀번호와 동일하게 입력해주세요</p>
                </div>
                <div class="form-box mb28">
                  <div class="form-group row" :class="{'error': isTelError}">
                    <HconInput type="text" v-model:model-value="inputTel" label="휴대전화번호" :hide-label="false" inputClass="md" buttonClass="btn-gray md" :showButton="true" buttonText="변경하기" placeholder="휴대전화번호 인증 시 자동 입력" readonly @buttonClick="passAuthenticate"/>
                  </div>
                  <p v-if="isTelError && isTelErrorType === 'null'" class="helper-text error">
                    {{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9107)}} <!-- 휴대전화 인증을 완료해주세요. -->
                  </p>
                  <p class="helper-text">* 휴대전화번호와 담당자명은 PASS 인증을 통해 확인되며 자동으로 입력됩니다.</p>
                </div>
                <div class="form-box mb28">
                  <div class="form-group row">
                    <HconInput type="text" v-model:model-value="inputHcUsrNm" label="담당자명" :hide-label="false" inputClass="md" placeholder="휴대전화번호 인증 시 자동 입력" disabled/>
                  </div>
                </div>
                <div class="form-box mb28">
                  <div class="form-group row">
                    <HconInput type="email" ref="inputEmlAdrRef" v-model:model-value="inputEmlAdr" label="이메일" :hide-label="false" inputClass="md" selectBoxTitleClass="md wd174" buttonClass="btn-gray md" :showButton="true" buttonText="중복확인" @buttonClick="checkDuplicatedEmailInfo"/>
                  </div>
                  <p class="helper-text">* 견적서 발송, 포인트 이용 내역, 약관 변경 등 주요 안내 메일 수신을 위해 사용됩니다.</p>
                </div>
                <div class="form-box mb28">
                  <div class="form-group row" :class="{'error': isHcUsrDeptCdHcUsrJrspCdError || isHcUsrDeptNmHcUsrJrspNmError}">
                    <label for="" class="inp-label">근무부서/직급</label>
                    <div class="col2">
                      <div class="col" :class="{'error': isHcUsrDeptCdError || isHcUsrDeptNmError}" v-if="!isLoadingA">
                        <HconDropDown type="commDropdownBox" placeholder="근무부서 선택" selectBoxTitleClass="md wd329" :commDropdownOptions="hcUsrDeptCd" v-model:model-value="selectedHcUsrDeptCd"/>
                        <div class="form-group mt10">
                          <HconInput type="text" v-model:model-value="inputHcUsrDeptNm" label="근무부서 직접입력" :hide-label="true" inputClass="md" placeholder="근무부서 직접입력" v-if="selectedHcUsrDeptCd === '1008'"/>
                        </div>
                        <p v-if="(isHcUsrDeptCdError && isHcUsrDeptCdErrorType === 'null') && (selectedHcUsrDeptCd === null || selectedHcUsrDeptCd === '')" class="helper-text error">
                          {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"근무부서를","선택")}} <!-- {근무부서를} {선택}해 주세요. -->
                        </p>
                        <p v-if="(isHcUsrDeptNmError && isHcUsrDeptNmErrorType === 'null') && (inputHcUsrDeptNm === null || inputHcUsrDeptNm === '')" class="helper-text error">
                          {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"근무부서 직접입력을","입력")}} <!-- {근무부서 직접입력을} {입력}해 주세요. -->
                        </p>
                      </div>
                      <div class="col" :class="{'error': isHcUsrJrspCdError || isHcUsrJrspNmError}" v-if="!isLoadingB">
                        <HconDropDown type="commDropdownBox" placeholder="직급 선택" selectBoxTitleClass="md wd329" :commDropdownOptions="hcUsrJrspCd" v-model:model-value="selectedHcUsrJrspCd"/>
                        <div class="form-group mt10">
                          <HconInput type="text" v-model:model-value="inputHcUsrJrspNm" label="직급 직접입력" :hide-label="true" inputClass="md" placeholder="직급 직접입력" v-if="selectedHcUsrJrspCd === '9999'"/>
                        </div>
                        <p v-if="(isHcUsrJrspCdError && isHcUsrJrspCdErrorType === 'null') && (selectedHcUsrJrspCd === null || selectedHcUsrJrspCd === '')" class="helper-text error">
                          {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"직급을","선택")}} <!-- {직급을} {선택}해 주세요. -->
                        </p>
                        <p v-if="(isHcUsrJrspNmError && isHcUsrJrspNmErrorType === 'null') && (inputHcUsrJrspNm === null || inputHcUsrJrspNm === '')" class="helper-text error">
                          {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"직급 직접입력을","입력")}} <!-- {직급 직접입력을} {입력}해 주세요. -->
                        </p>
                      </div>
                    </div>
                  </div>
                  <p v-if="(isHcUsrDeptCdHcUsrJrspCdError && isHcUsrDeptCdHcUsrJrspCdErrorType === 'null')" class="helper-text error">
                    {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"근무부서와 직급을 모두","선택")}} <!-- {근무부서와 직급을 모두} {선택}해 주세요. -->
                  </p>
                  <p v-if="isHcUsrDeptNmHcUsrJrspNmError && isHcUsrDeptNmHcUsrJrspNmErrorType === 'null'" class="helper-text error">
                    {{HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9001,"근무부서와 직급 직접입력을 모두","입력")}} <!-- {근무부서와 직급 직접입력을 모두} {입력}해 주세요. -->
                  </p>
                </div>
                <div class="form-box mb28">
                  <div class="form-group row">
                    <HconInput type="tel" ref="inputCbleTelRef" v-model:model-value="inputCbleTel" label="유선 전화번호" inputClass="md" selectBoxTitleClass="md wd207" :hide-label="false"/>
                  </div>
                </div>
                <div class="form-box mb28">
                  <div class="form-group row">
                    <strong class="inp-label">가입일자</strong>
                    <span class="col2">{{moment(usrInfo?.joinDtm,'YYYYMMDD').format('YYYY-MM-DD')}}</span>
                  </div>
                </div>
              </fieldset>
              <div class="form-box mb28">
                <div class="form-group row">
                  <strong class="inp-label">회원 탈퇴</strong>
                  <span class="col2"><NuxtLink to="/pc/mypage/information/member-drop-out" class="btn btn-outline btn-outline-green xs">회원탈퇴</NuxtLink></span>
                </div>
              </div>
            </div> 
          </div> 
          <!-- 부가 정보 영역 -->
          <div class="content-box last-box mb40">
            <div class="border-title title">
              <h3 class="title">부가정보 입력</h3>
            </div>
            <div class="contents-detail-wrap border-btm">
              <div class="form-box term-box">
                <div class="form-group row mt38 mb38">
                  <strong class="inp-label">마케팅 수신 동의</strong>
                  <div class="term-info-box m0">
                    <p>이벤트&쇼핑 정보를 선택하신 수단으로 전송합니다.</p>
                    <div class="form-group">
                      <HconCheckBox type="default" :checked="checkedAraiYnSmsLms === 'Y' ? true : false" @change="changeCheckedAraiYnSmsLms" label="문자알림" name="snsCheck" :hide-label="false"/>
                      <HconCheckBox type="default" :checked="checkedAraiYnKakao === 'Y' ? true : false" @change="changeCheckedAraiYnKakao" label="알림톡" name="alimtalkCheck" :hide-label="false"/>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
          </div> 
          <!-- 버튼 영역 -->
          <div class="button-box col2">
            <button type="button" @click="showMemberModifyCancelConfirm" class="btn btn-outline lg">취소</button>
            <button type="button" @click="showMemberModifyAlert" class="btn lg">회원정보 수정</button>
          </div>
        </form>
      </div> 
    </div>
  </div>
  <!-- 비밀번호 확인 팝업 -->
  <HconComPasswordCheckPopup v-if="!isPasswordChecked" @success="handleCheckSuccess"/>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import moment from 'moment-timezone';
import HconInput from '@/components/com/HconComPCInputField.vue'
import HconDropDown from '@/components/com/HconComPCDropDown.vue'
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'
import HconComPasswordCheckPopup from '~/components/com/HconComPasswordCheckPopup.vue';
import HconMyPageSideMenu from '@/components/corner/pc/HconCornerMypageSideMenuPC.vue';
import HconMyPageUsrInfo from '@/components/corner/pc/HconCornerUserInfoPC.vue';
import { usePopup } from '@/composables/hconUsePopup'
import { useHconFetchBuilder } from "~/composables/hcon-fetch-builder";
import { useHconRefCommonCode } from "~/composables/hcon-ref-common-code";
import { HconCommonRegExp } from '@/constants/hconRegexConstants'
import { COMMON_CODE, MEMBER_CODE, ORDER_CODE } from "@/constants/hconMessageConstants";
import type { UserInfoResDto } from '~/types/mypage/backend-dto-types';
import type { BizcDto, BiztpDto, BizcBiztpDto } from '~/types/common/backend-dto-types';
import type { MemberInfoDuplicateCheckDto } from '~/types/member/join/backend-dto-types';
import { HconCommonUtils } from "@/utils/hcon-common-utils"

// 팝업
const {showAlert, showConfirm} = usePopup()

// 패스워드 확인 팝업 검증 여부
const isPasswordChecked = ref(false)

// 패스워드 확인 팝업 검증 성공 후 이벤트
const handleCheckSuccess = async () => {
  isPasswordChecked.value = true
  await callApiList();
}

// 마이페이지 회원 정보 관리 초기 호출 API 목록
const callApiList = async () => {
  userBizcBiztpInfo();
  userInfo();
}

// 공통코드 목록 조회
const {codeDataList:hcUsrDeptCd, isLoading: isLoadingA} = useHconRefCommonCode('hc_usr_dept_cd'); // HCON사용자부서코드
const {codeDataList:hcUsrJrspCd, isLoading: isLoadingB} = useHconRefCommonCode('hc_usr_jrsp_cd'); // HCON사용자직책코드

// 사용자ID 세션 값 세팅
const userId = useHconAuthInfo().getIfPossible()?.userContext.userId;

// 업태코드 정보 조회 API 결과 값
const bizcInfo = ref<BizcDto[]>();
// 업종코드 정보 조회 API 결과 값
const biztpInfo = ref<BiztpDto[]>();
// 회원 정보 조회 API 결과 값
const usrInfo = ref<UserInfoResDto>();

// 업태
const selectedBizcCd = ref("");
const isBizcCdError = ref(false)
const isBizcCdErrorType = ref("")

// 업태 직접입력
const inputBizcNm = ref("");
const isBizcNmError = ref(false)
const isBizcNmErrorType = ref("")

// 업종
const selectedBiztpCd = ref("");
const isBiztpCdError = ref(false)
const isBiztpCdErrorType = ref("")

// 업종 직접입력
const inputBiztpNm = ref("");
const isBiztpNmError = ref(false)
const isBiztpNmErrorType = ref("")

// 업태/업종 
const isBizcCdBiztpCdError = ref(false)
const isBizcCdBiztpCdErrorType = ref("")

// 업태/업종 직접입력
const isBizcNmBiztpNmError = ref(false)
const isBizcNmBiztpNmErrorType = ref("")

// 사업장 주소
const inputAddress = ref("");
const inputAddressRef = ref<InstanceType<typeof HconInput> | null>(null)
const isAddressError = ref(false)
const isAddressErrorType = ref("")

// 비밀번호
const inputPassword = ref("")
const inputPasswordRef = ref<InstanceType<typeof HconInput> | null>(null)
const isPasswordError = ref(false)
const isPasswordErrorType = ref("")

// 비밀번호 확인
const inputPasswordCheck = ref("")
const inputPasswordCheckRef = ref<InstanceType<typeof HconInput> | null>(null)
const isPasswordCheckError = ref(false)
const isPasswordCheckErrorType = ref("")

// 담당자휴대전화번호
const inputTel = ref("")
const isTelError = ref(false)
const isTelErrorType = ref("")

// 담당자명
const inputHcUsrNm = ref("")

// 담당자암호화CI
const selectedUsrEncCi = ref("")

// 담당자본인인증생년월일일자
const selectedSelfCrtfBymdCt = ref("")

// 담당자본인인증성별숫자값
const selectedSelfCrtfGndrNval = ref()

// 이메일
const inputEmlAdr = ref("")
const inputEmlAdrRef = ref<InstanceType<typeof HconInput> | null>(null)

// 근무부서
const selectedHcUsrDeptCd = ref("");
const isHcUsrDeptCdError = ref(false)
const isHcUsrDeptCdErrorType = ref("")

// 근무부서 직접입력
const inputHcUsrDeptNm = ref("");
const isHcUsrDeptNmError = ref(false)
const isHcUsrDeptNmErrorType = ref("")

// 직급
const selectedHcUsrJrspCd = ref("");
const isHcUsrJrspCdError = ref(false)
const isHcUsrJrspCdErrorType = ref("")

// 직급 직접입력
const inputHcUsrJrspNm = ref("");
const isHcUsrJrspNmError = ref(false)
const isHcUsrJrspNmErrorType = ref("")

// 근무부서/직급
const isHcUsrDeptCdHcUsrJrspCdError = ref(false)
const isHcUsrDeptCdHcUsrJrspCdErrorType = ref("")

// 근무부서/직급 직접입력
const isHcUsrDeptNmHcUsrJrspNmError = ref(false)
const isHcUsrDeptNmHcUsrJrspNmErrorType = ref("")

// 유선 전화번호
const inputCbleTel = ref("")
const inputCbleTelRef = ref<InstanceType<typeof HconInput> | null>(null)

// 마케팅 수신 동의(문자알림)
const checkedAraiYnSmsLms = ref("")

// 마케팅 수신 동의(알림톡)
const checkedAraiYnKakao = ref("")

// 마케팅 수신 동의(문자알림) 체크박스 change 이벤트 
const changeCheckedAraiYnSmsLms = (isCheckedAraiYnSmsLms : boolean) => {
  checkedAraiYnSmsLms.value = isCheckedAraiYnSmsLms ? 'Y' :'N'
}

// 마케팅 수신 동의(알림톡) 체크박스 change 이벤트 
const changeCheckedAraiYnKakao = (isCheckedAraiYnKakao : boolean) => {
  checkedAraiYnKakao.value = isCheckedAraiYnKakao ? 'Y' :'N'
}

// validate checkFlag
const checkFlag = ref(false);
// 이메일 checkFlag
const emailCheckFlag = ref(false);
// 이메일 validate checkFlag
const emailValidateFlag = ref(false);
// 이메일 duplicate checkFlag
const emailDuplicateCheckFlag = ref(false);
// 유선 전화번호 validate checkFlag
const cbleTelnoValidateFlag = ref(false);
// PASS 인증 checkFlag
const checkPassFlag = ref(true);

// validate 체크
const validateCheck = async () => {

  isBizcCdBiztpCdError.value = false
  isBizcCdBiztpCdErrorType.value = ""
  isBizcNmBiztpNmError.value = false
  isBizcNmBiztpNmErrorType.value = ""
  isBizcCdError.value = false
  isBizcCdErrorType.value = ""
  isBizcNmError.value = false
  isBizcNmErrorType.value = ""
  isBiztpCdError.value = false
  isBiztpCdErrorType.value = "" 
  isBiztpNmError.value = false
  isBiztpNmErrorType.value = ""
  isAddressError.value = false
  isAddressErrorType.value = ""
  isPasswordError.value = false
  isPasswordErrorType.value = ""
  isPasswordCheckError.value = false
  isPasswordCheckErrorType.value = ""
  isTelError.value = false
  isTelErrorType.value = "" 
  emailCheckFlag.value = false
  emailValidateFlag.value = false
  isHcUsrDeptCdHcUsrJrspCdError.value = false
  isHcUsrDeptCdHcUsrJrspCdErrorType.value = ""
  isHcUsrDeptNmHcUsrJrspNmError.value = false
  isHcUsrDeptNmHcUsrJrspNmErrorType.value = ""
  isHcUsrDeptCdError.value = false
  isHcUsrDeptCdErrorType.value = ""
  isHcUsrDeptNmError.value = false
  isHcUsrDeptNmErrorType.value = ""
  isHcUsrJrspCdError.value = false
  isHcUsrJrspCdErrorType.value = ""
  isHcUsrJrspNmError.value = false
  isHcUsrJrspNmErrorType.value = ""
  cbleTelnoValidateFlag.value = false

  // 업태/업종 Null 체크
  if(HconCommonUtils.isEmpty(selectedBizcCd.value) && HconCommonUtils.isEmpty(selectedBiztpCd.value)) {
    isBizcCdBiztpCdError.value = true
    isBizcCdBiztpCdErrorType.value = 'null'
    // 이메일 validate 값 초기화
    if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
      emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
    }
    return checkFlag.value = false
  }

  isBizcCdBiztpCdError.value = false
  isBizcCdBiztpCdErrorType.value = ""

  // 업태/업종 직접입력 Null 체크
  if((selectedBizcCd.value === 'Z' && HconCommonUtils.isEmpty(inputBizcNm.value)) &&
    (selectedBiztpCd.value === '999999' && HconCommonUtils.isEmpty(inputBiztpNm.value))
  ) {
    isBizcNmBiztpNmError.value = true
    isBizcNmBiztpNmErrorType.value = 'null'
    // 이메일 validate 값 초기화
    if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
      emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
    }
    return checkFlag.value = false
  }

  isBizcNmBiztpNmError.value = false
  isBizcNmBiztpNmErrorType.value = ""

  // 업태 Null 체크
  if(HconCommonUtils.isEmpty(selectedBizcCd.value)) {
    isBizcCdError.value = true
    isBizcCdErrorType.value = 'null'
    // 이메일 validate 값 초기화
    if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
      emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
    }
    return checkFlag.value = false
  }

  isBizcCdError.value = false
  isBizcCdErrorType.value = ""

  // 업태 직접입력 Null 체크
  if(selectedBizcCd.value === 'Z' && HconCommonUtils.isEmpty(inputBizcNm.value)) {
    isBizcNmError.value = true
    isBizcNmErrorType.value = 'null'
    // 이메일 validate 값 초기화
    if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
      emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
    }
    return checkFlag.value = false
  }

  isBizcNmError.value = false
  isBizcNmErrorType.value = ""

  // 업종 Null 체크
  if(HconCommonUtils.isEmpty(selectedBiztpCd.value)) {
    isBiztpCdError.value = true
    isBiztpCdErrorType.value = 'null'
    // 이메일 validate 값 초기화
    if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
      emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
    }
    return checkFlag.value = false
  }

  isBiztpCdError.value = false
  isBiztpCdErrorType.value = "" 

  // 업종 직접입력 Null 체크
  if(selectedBiztpCd.value === '999999' && HconCommonUtils.isEmpty(inputBiztpNm.value)) {
    isBiztpNmError.value = true
    isBiztpNmErrorType.value = 'null'
    // 이메일 validate 값 초기화
    if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
      emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
    }
    return checkFlag.value = false
  }

  isBiztpNmError.value = false
  isBiztpNmErrorType.value = ""

  // 사업장 주소 Null 체크
  if(HconCommonUtils.isEmpty(inputAddress.value)) {
    // 사업장 주소 Focus 적용
    if(inputAddressRef.value) {
      inputAddressRef.value.onInputTextFocus();
    }
    isAddressError.value = true
    isAddressErrorType.value = 'null'
    // 이메일 validate 값 초기화
    if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
      emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
    }
    return checkFlag.value = false
  }

  isAddressError.value = false
  isAddressErrorType.value = ""

  // 비밀번호 (영문,숫자,특수문자 9~20자) 체크
  if(HconCommonUtils.isNotEmpty(inputPassword.value) && !HconCommonRegExp.PASSWORD_REGEX.test(inputPassword.value)) {
    // 비밀번호 Focus 적용
    if(inputPasswordRef.value) {
      inputPasswordRef.value.onPasswordFocus();
    }
    isPasswordError.value = true
    isPasswordErrorType.value = 'format1'
    // 이메일 validate 값 초기화
    if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
      emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
    }
    return checkFlag.value = false
  }

  // 비밀번호 (동일한 문자/숫자 3회 이상 반복 금지, 연속된 문자/숫자 3회 이상 금지) 체크
  if(HconCommonUtils.isNotEmpty(inputPassword.value) && (!HconCommonRegExp.PASSWORD_NO_REPEAT_REGEX.test(inputPassword.value) || !HconCommonRegExp.PASSWORD_NO_CONTINUATION_REGEX.test(inputPassword.value))) {
    // 비밀번호 Focus 적용
    if(inputPasswordRef.value) {
      inputPasswordRef.value.onPasswordFocus();
    }
    isPasswordError.value = true
    isPasswordErrorType.value = 'format2'
    // 이메일 validate 값 초기화
    if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
      emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
    }
    return checkFlag.value = false
  }

  isPasswordError.value = false
  isPasswordErrorType.value = ""

  // 비밀번호 확인란 Null 체크
  if(HconCommonUtils.isNotEmpty(inputPassword.value) && HconCommonUtils.isEmpty(inputPasswordCheck.value)) {
    // 비밀번호 확인란 Focus 적용
    if(inputPasswordCheckRef.value) {
      inputPasswordCheckRef.value.onPasswordFocus();
    }
    isPasswordCheckError.value = true
    isPasswordCheckErrorType.value = 'null'
    // 이메일 validate 값 초기화
    if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
      emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
    }
    return checkFlag.value = false
  }

  // 비밀번호와 비밀번호 확인란 일치 여부 체크
  if(inputPassword.value !== inputPasswordCheck.value) {
    // 비밀번호 확인란 Focus 적용
    if(inputPasswordCheckRef.value) {
      inputPasswordCheckRef.value.onPasswordFocus();
    }
    isPasswordCheckError.value = true
    isPasswordCheckErrorType.value = 'match'
    // 이메일 validate 값 초기화
    if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
      emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
    }
    return checkFlag.value = false
  }

  isPasswordCheckError.value = false
  isPasswordCheckErrorType.value = ""

  // PASS 인증 체크
  if(HconCommonUtils.isEmpty(inputTel.value) || HconCommonUtils.isEmpty(inputHcUsrNm.value) || checkPassFlag.value === false) {
    isTelError.value = true
    isTelErrorType.value = 'null'
    // 이메일 validate 값 초기화 
    if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
      emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
    }
    return checkFlag.value = false
  }

  isTelError.value = false
  isTelErrorType.value = "" 

  emailCheckFlag.value = true

  // 이메일 validate 체크
  if(inputEmlAdrRef.value && emailValidateFlag.value === false) {
    emailValidateFlag.value = inputEmlAdrRef.value.onEmailAdrValidate(emailCheckFlag.value)
  }
  
  if(emailValidateFlag.value === true) {

    // 이메일 duplicate 체크(기존 이메일하고 다른 경우에 check)
    if(emailDuplicateCheckFlag.value === false && usrInfo?.value?.emlAdr !== inputEmlAdr.value) {
      showAlert({
        title: '알림',
        message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9108) /*이메일 중복확인을 진행해주세요.*/
      }) 
      return checkFlag.value = false;
    }

    // 근무부서/직급 Null 체크
    if(HconCommonUtils.isEmpty(selectedHcUsrDeptCd.value) && HconCommonUtils.isEmpty(selectedHcUsrJrspCd.value)) {
      isHcUsrDeptCdHcUsrJrspCdError.value = true
      isHcUsrDeptCdHcUsrJrspCdErrorType.value = 'null' 
      return checkFlag.value = false;
    }

    isHcUsrDeptCdHcUsrJrspCdError.value = false
    isHcUsrDeptCdHcUsrJrspCdErrorType.value = ""

    // 근무부서/직급 직접입력 Null 체크
    if((selectedHcUsrDeptCd.value === '1008' && HconCommonUtils.isEmpty(inputHcUsrDeptNm.value)) &&
      (selectedHcUsrJrspCd.value === '9999' && HconCommonUtils.isEmpty(inputHcUsrJrspNm.value))
    ) {
      isHcUsrDeptNmHcUsrJrspNmError.value = true
      isHcUsrDeptNmHcUsrJrspNmErrorType.value = 'null'
      return checkFlag.value = false; 
    }

    isHcUsrDeptNmHcUsrJrspNmError.value = false
    isHcUsrDeptNmHcUsrJrspNmErrorType.value = ""

    // 근무부서 Null 체크
    if(HconCommonUtils.isEmpty(selectedHcUsrDeptCd.value)) {
      isHcUsrDeptCdError.value = true
      isHcUsrDeptCdErrorType.value = 'null' 
      return checkFlag.value = false;
    }

    isHcUsrDeptCdError.value = false
    isHcUsrDeptCdErrorType.value = ""

    // 근무부서 직접입력 Null 체크
    if(selectedHcUsrDeptCd.value === '1008' && HconCommonUtils.isEmpty(inputHcUsrDeptNm.value)) {
      isHcUsrDeptNmError.value = true
      isHcUsrDeptNmErrorType.value = 'null'
      return checkFlag.value = false; 
    }

    isHcUsrDeptNmError.value = false
    isHcUsrDeptNmErrorType.value = ""

    // 직급 Null 체크
    if(HconCommonUtils.isEmpty(selectedHcUsrJrspCd.value)) {
      isHcUsrJrspCdError.value = true
      isHcUsrJrspCdErrorType.value = 'null' 
      return checkFlag.value = false;
    }

    isHcUsrJrspCdError.value = false
    isHcUsrJrspCdErrorType.value = ""

    // 직급 직접입력 Null 체크
    if(selectedHcUsrJrspCd.value === '9999' && HconCommonUtils.isEmpty(inputHcUsrJrspNm.value)) {
      isHcUsrJrspNmError.value = true
      isHcUsrJrspNmErrorType.value = 'null'
      return checkFlag.value = false; 
    }

    isHcUsrJrspNmError.value = false
    isHcUsrJrspNmErrorType.value = ""

    // 유선 전화번호 validate 체크
    if(inputCbleTelRef.value && cbleTelnoValidateFlag.value === false) {
      cbleTelnoValidateFlag.value = inputCbleTelRef.value.onCbleTelnoValidate(true)
    } 
    
    if(cbleTelnoValidateFlag.value === true) {
      checkFlag.value = true
    }
    
    return checkFlag.value;
    
  }
}

// 업태코드 key, value 드롭다운 명 세팅
const bizcInfoList = computed(() => {
  if(bizcInfo.value) {
    return bizcInfo.value.map(item => {
      return {
        key: item.hcBizcCd,
        value: item.hcBizcNm
      }
    })
  }
})

// 업종코드 key, value 드롭다운 명 세팅
const biztpInfoList = computed(() => {
  if(biztpInfo.value) {
    return biztpInfo.value
    .filter(sector => sector.hcBizcCd === selectedBizcCd.value)
    .map(item => {
      return {
        key: item.hcBiztpCd,
        value: item.hcBiztpNm
      }
    })
  }
})

const fetchBuilder  = useHconFetchBuilder();

// 업태/업종코드 정보 조회 API 호출
const userBizcBiztpInfo = async () => {
  const fetchBuilderResult = 
  await fetchBuilder.get<AjaxResult<BizcBiztpDto>>('/api/v1/common/codes/bizcBiztp')
  .progressMessage("잠시만 기다려주세요...")
  .preventErrorNotify()
  .build()
  .execute()
  .then((result) => {
    if(result.resultCode == '200') {
      bizcInfo.value = result.data.bizcList
      biztpInfo.value = result.data.biztpList
    } 
  })
  .catch((error) => {
    // 응답코드가 200이 아닌경우
    if(error.resultCode != '200') {
      showAlert(error.resultMessage)
    }
  })
}

// 회원 정보 조회 API 호출
const userInfo = async () => {
  const fetchBuilderResult = 
  await fetchBuilder.get<AjaxResult<UserInfoResDto>>('/api/v1/mypage/information/userInfo')
  .query()
  .progressMessage("잠시만 기다려주세요...")
  .preventErrorNotify()
  .build()
  .execute()
  .then((result) => {
    if(result.resultCode == '200') {
      usrInfo.value = result.data
      // 회원 정보 값 초기 세팅
      selectedBizcCd.value = usrInfo.value.hcBizcCd
      inputBizcNm.value = usrInfo.value.usrInsrBizcNm
      selectedBiztpCd.value = usrInfo.value.hcBiztpCd
      inputBiztpNm.value = usrInfo.value.usrInsrBiztpNm
      inputAddress.value = usrInfo.value.basAdr
      inputTel.value = usrInfo.value.hcUsrMblTelno
      inputHcUsrNm.value = usrInfo.value.hcUsrNm
      selectedUsrEncCi.value = usrInfo.value.usrEncCi
      selectedSelfCrtfBymdCt.value = usrInfo.value.selfCrtfBymdDt
      selectedSelfCrtfGndrNval.value = usrInfo.value.selfCrtfGndrNval
      selectedHcUsrDeptCd.value = usrInfo.value.hcUsrDeptCd
      inputHcUsrDeptNm.value = usrInfo.value.usrInsrDeptNm
      selectedHcUsrJrspCd.value = usrInfo.value.hcUsrJrspCd
      inputHcUsrJrspNm.value = usrInfo.value.usrInsrJrspNm
      inputEmlAdr.value = usrInfo.value.emlAdr
      inputCbleTel.value = usrInfo.value.hcAreaNoCd !== '999' ? HconCommonUtils.format.phone(usrInfo.value.hcAreaNoCd + usrInfo.value.cbleTelno) : usrInfo.value.hcAreaNoCd + "-" + HconCommonUtils.format.phone(usrInfo.value.usrInsrAreaNoNm + usrInfo.value.cbleTelno)
      checkedAraiYnSmsLms.value = usrInfo.value.araiYnSmsLms
      checkedAraiYnKakao.value = usrInfo.value.araiYnKakao
    }
  })
  .catch((error) => {
    // 응답코드가 200이 아닌경우
    if(error.resultCode != '200') {
      showAlert(error.resultMessage)
    }
  })
}

// PASS 인증 API 호출
const passAuthenticate = async () => {
  const fetchBuilderResult = 
  await fetchBuilder.get<AjaxResult<any>>("/api/v1/certificate/get-certificate-url")
  .query()
  .progressMessage("잠시만 기다려주세요...")
  .preventErrorNotify()
  .build()
  .execute()
  .then((result) => {
    sessionStorage.setItem('common.auth.transaction_id', result.data.transaction_id)
    const popup = window.open(result.data.auth_url,'popupPhoneCert','width=600, height=1110, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no')
    window.addEventListener("message", (event) => {
    if(event.data.returnCode === "0000") {
      showAlert({
        message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, "휴대전화번호 인증이") /*{휴대전화번호 인증이} 완료되었습니다.*/
      });
      inputTel.value = event.data.authResultData.mobile_no
      inputHcUsrNm.value = event.data.authResultData.name
      selectedUsrEncCi.value = event.data.authResultData.ci
      selectedSelfCrtfBymdCt.value = event.data.authResultData.birthdate
      selectedSelfCrtfGndrNval.value = event.data.authResultData.gender
    } 
    else {
      showAlert({
        message : MEMBER_CODE.ALT_HCON_9034 /*본인 인증이 실패했습니다. 다시 시도해주세요.*/
      });

      checkPassFlag.value = false

      return false;
    }
    })
    
  if(popup === null || typeof popup ==='undefined') {
    alert('브라우저에서 팝업이 차단되었습니다. 팝업 차단을 해제해주세요.');
  }
  else{
    popup.focus();
  }

  });
}

// 이메일 중복확인 API 호출
const checkDuplicatedEmailInfo = async () => {
  
  // 중복확인 값 (이메일)
  const infoValue = 'email';

  const fetchBuilderResult = 
  await fetchBuilder.post<AjaxResult<MemberInfoDuplicateCheckDto>>('/api/v1/member/join/check-duplicated-memberInfo/' + infoValue)
  .body({
    hcUsrId: userId,
    emlAdr: inputEmlAdr.value
  })
  .progressMessage("잠시만 기다려주세요...")
  .preventErrorNotify()
  .build()
  .execute()
  .then((result) => {
    if(result.resultCode == '200') {
      // 기존에 회원정보로 등록되어있는 이메일이 아니면서 중복된 이메일인 경우
      if(result?.data.duplicatedYn === 'Y' && (usrInfo.value?.emlAdr !== inputEmlAdr.value)) {
        showAlert({
          title: '알림', 
          message : HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9035) /*이미 가입된 이메일입니다. 다른 이메일을 입력해 주세요.*/
        }); 
        checkFlag.value = false;
        emailDuplicateCheckFlag.value = false;
      }
      else {
        showAlert({
          title: '알림', 
          message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, "이메일 중복확인이") /*{이메일 중복확인이} 완료되었습니다.*/
        }); 
        emailDuplicateCheckFlag.value = true;
      } 
    }
  })
  .catch((error) => {
    // 응답코드가 200이 아닌경우
    if(error.resultCode != '200') {
      showAlert(error.resultMessage)
    }
  })
}

// 회원 정보 변경 API 호출
const changeUserInfo = async () => {
  const fetchBuilderResult = 
  await fetchBuilder.put<AjaxResult<boolean>>('/api/v1/mypage/information/userInfo-change')
  .body({
    hcUsrNm: inputHcUsrNm.value,
    hcUsrMblTelno: inputTel.value,
    selfCrtfBymdDt: selectedSelfCrtfBymdCt.value,
    selfCrtfGndrNval: selectedSelfCrtfGndrNval.value,
    usrEncCi: selectedUsrEncCi.value,
    emlAdr: inputEmlAdr.value,
    newPassword: inputPassword.value.trim(),
    hcBizcCd: selectedBizcCd.value,
    usrInsrBizcNm: inputBizcNm.value,
    hcBiztpCd: selectedBiztpCd.value,
    usrInsrBiztpNm: inputBiztpNm.value,
    hcUsrDeptCd: selectedHcUsrDeptCd.value,
    usrInsrDeptNm: inputHcUsrDeptNm.value,
    hcUsrJrspCd: selectedHcUsrJrspCd.value,
    usrInsrJrspNm: inputHcUsrJrspNm.value,
    hcAreaNoCd: inputCbleTel.value.split('-')[0],
    usrInsrAreaNoNm: inputCbleTel.value.split('-')[0] === '999' ? inputCbleTel.value.split('-')[1] : '',
    cbleTelno: inputCbleTel.value.split('-')[0] === '999' ? 
               inputCbleTel.value.substring(inputCbleTel.value.indexOf('-',inputCbleTel.value.indexOf('-') +1) +1).replace(/-/g,'') : 
               inputCbleTel.value.substring(inputCbleTel.value.indexOf('-')).replace(/-/g,''),
    basAdr: inputAddress.value,
    araiYnKakao: checkedAraiYnKakao.value,
    araiYnSmsLms: checkedAraiYnSmsLms.value
  })
  .progressMessage("잠시만 기다려주세요...")
  .preventErrorNotify()
  .build()
  .execute()
  .then((result) => {
    // 회원정보 변경이 정상적으로 이루어진 경우 마이페이지 홈으로 이동
    if(result.resultCode == '200') {
      if(result.data === true) {
        showAlert({
          title: '알림', 
          message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, "회원정보 변경이"), /*{회원정보 변경이} 완료되었습니다.*/
          onConfirm: () => {
            navigateTo({path: '/pc/mypage'}, {external: false})
          }
        })
      }
    }
  })
  .catch((error) => {
    // 응답코드가 200이 아닌경우
    if(error.resultCode != '200') {
      showAlert(error.resultMessage)
    }
  })
}

// 취소 버튼 click 이벤트
const showMemberModifyCancelConfirm = () => {
  const result = showConfirm({
    title: '알림',
    message : HconCommonUtils.format.message(ORDER_CODE.ALT_HCON_9043) /*수정 중인 내용이 저장되지 않습니다. 정말 나가시겠습니까?*/,
    confirmText: '확인',
    onConfirm: () => {
      navigateTo({path: '/pc/mypage'}, {external: false})
    },
    cancelText: '취소'
  })
}

// 회원정보 수정 버튼 click 이벤트
const showMemberModifyAlert = () => {
  validateCheck();
  if(checkFlag.value === true) {
    changeUserInfo();
  }
}
</script>
<style lang="scss" scoped> 
@use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>